<template>
  <b-container>
    <h1>{{ $t("gasStation.create") }}</h1>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="danger" :msg="alert.error" />

    <b-row class="mb-3 ml-0">
      <router-link :to="getUrlBackToList">
        <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
      </router-link>
    </b-row>
    <b-row>
      <b-col sm="12" md="6" lg="6">
        <GasStationCrud
          ref="crudData"
          :model="model"
          :modelstate="modelstate"
        />
      </b-col>
    </b-row>

    <!-- {{ model }} -->
    <b-button @click="save()" type="submit" :disabled="submitted">
      {{ $t("geral.save") }}
    </b-button>
  </b-container>
</template>
  <script>
export default {
  name: "GasStationCreate",
  components: {
    GasStationCrud: () =>
      import("@/components_rms/fuelSupplies/gasStation/GasStationCrud.vue"),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  computed: {
    getUrlBackToList() {
      return `../gasStation/list`;
    },
  },
  data() {
    return {
      alert: {
        error: "",
        success: this.$t("gasStation.createSuccess"),
      },
      submitted: false,
      model: {
        documentNumber: "",
        companyName: "",
        fantasyName: "",
        cityId: null,
        isExternalGasStation: false,
        isInternalGasStation: false,
      },
      modelstate: {},
    };
  },
  methods: {
    save() {
      this.submitted = true;
      this.$apiVehicle
        .post("/gasStation/create/", this.model)
        .then((response) => {
          this.modelstate = {};
          this.cleanModel();
          this.submitted = false;
          this.$refs.alert.show();
        })
        .catch((error) => {
          this.submitted = false;

          console.log(error);
          console.log(error.response);
          console.log(error.errorCode);

          switch (error.response.status) {
            case 401:
              this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
              });
              break;
            case 400:
              if (error.response.data.errorCode) {
                this.modelstate = error.response.data.errors;
                this.alert.error = `${error.response.data.errorCode} - ${error.response.data.errorMessage}`;
                this.$refs.danger.show();
              } else {
                this.modelstate = error.response.data.errors;
                this.alert.error = error.message;
                this.$refs.danger.show();
              }
              break;
            default:
              if (error.response.data.errorCode) {
                this.modelstate = error.response.data.errors;
                this.alert.error = `${error.response.data.errorCode} - ${error.response.data.errorMessage}`;
                this.$refs.danger.show();
              } else {
                this.modelstate = {};
                this.alert.error = error.message;
                this.$refs.danger.show();
              }
              break;
          }
        });
    },
    cleanModel() {
      this.model = {
        documentNumber: "",
        companyName: "",
        fantasyName: "",
        cityId: null,
        isExternalGasStation: false,
        isInternalGasStation: false,
      };
    },
  },
};
</script>
  